// auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const tokenUser = localStorage.getItem('tokenUser');
    const tokenTenant = localStorage.getItem('tokenTenant');
    const tokenLocal = localStorage.getItem('token');
    const platform = localStorage.getItem('src_app');

    console.log('🛡️ AuthGuard - Checking authentication for platform:', platform);

    // Check if platform is selected
    if (!platform) {
      console.log('❌ No platform selected, redirecting to welcome');
      this.router.navigate(['/welcome']);
      return false;
    }

    if (platform === 'pharmalien') {
      // Pharmalien platform: only needs tokenUser and tokenLocal
      if (tokenUser && tokenLocal) {
        try {
          const isTokenUserValid = this.checkTokenExpiration(tokenUser);
          const isTokenLocalValid = this.checkTokenExpiration(tokenLocal);

          if (isTokenUserValid && isTokenLocalValid) {
            console.log('✅ Pharmalien authentication successful');
            return true;
          } else {
            console.log('❌ Pharmalien tokens expired');
          }
        } catch (error) {
          console.error('Token validation error:', error);
        }
      } else {
        console.log('❌ Missing Pharmalien tokens - tokenUser:', !!tokenUser, 'tokenLocal:', !!tokenLocal);
      }
    } else if (platform === 'windoc_direct') {
      // WinDoc Direct platform: only needs tokenLocal
      if (tokenLocal) {
        try {
          const isTokenLocalValid = this.checkTokenExpiration(tokenLocal);

          if (isTokenLocalValid) {
            console.log('✅ Windoc Direct authentication successful');
            return true;
          } else {
            console.log('❌ Windoc Direct token expired');
          }
        } catch (error) {
          console.error('Windoc Direct token validation error:', error);
        }
      } else {
        console.log('❌ Missing Windoc Direct token');
      }
    } else if (platform === 'winpluspharma') {
      // WinPlus platform: needs all three tokens
      if (tokenUser && tokenTenant && tokenLocal) {
        try {
          const isTokenUserValid = this.checkTokenExpiration(tokenUser);
          const isTokenTenantValid = this.checkTokenExpiration(tokenTenant);
          const isTokenLocalValid = this.checkTokenExpiration(tokenLocal);

          if (isTokenUserValid && isTokenTenantValid && isTokenLocalValid) {
            console.log('✅ WinPlus authentication successful');
            return true;
          } else {
            console.log('❌ WinPlus tokens expired');
          }
        } catch (error) {
          console.error('Token validation error:', error);
        }
      } else {
        console.log('❌ Missing WinPlus tokens - tokenUser:', !!tokenUser, 'tokenTenant:', !!tokenTenant, 'tokenLocal:', !!tokenLocal);
      }
    }

    // If any required token is missing or expired, redirect to login
    console.log('🔄 Redirecting to login due to authentication failure');
    this.router.navigate(['/login']);
    return false;
  }

  private checkTokenExpiration(token: string): boolean {
    const decodedToken: any = jwtDecode(token);
    const expiration = moment(decodedToken?.exp * 1000);
    return moment(new Date()) < expiration;
  }
}